/* @ngInject */ export function AccountsServices(HTTPService) {
  var http = HTTPService.make('/accountAdmin/');

  this.addAccountsToSites = function (accountIDs, sites) {
    return http.post('addAccountsToSites', {
      accountIDs: accountIDs,
      siteIDs: sites
    });
  };
  this.dropGroup = function (groupID) {
    return http.post('dropGroup/{0}'.format(groupID));
  };
  this.getAccount = function (acctID) {
    return http.post('getAccount/{0}'.format(acctID));
  };
  this.getAccountSettings = function () {
    return http.post('getAccountSettings');
  };
  this.getChildSites = function () {
    return http.post('getChildSites');
  };
  this.getGroup = function (groupID) {
    return http.post('getGroup/{0}'.format(groupID));
  };
  this.getList = function () {
    return http.post('getList');
  };
  this.getAccountGroups = function () {
    return http.post('getAccountGroups');
  };
  this.getTypes = function () {
    return http.post('getTypes');
  };
  this.removeAccount = function (acctID) {
    return http.post('removeAccount/{0}'.format(acctID));
  };
  this.saveAccount = function (acct) {
    return http.post('saveAccount', acct);
  };
  this.saveAccountGroup = function (group) {
    return http.post('saveAccountGroup', group);
  };
  this.saveAccountSettings = function (accountIDs) {
    return http.post('saveAccountSettings', accountIDs);
  };
}

